
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11413",
                "data-name": "矩形 11413",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(0.5 0)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_350",
        "data-name": "蒙版组 350",
        "class": "cls-2",
        "transform": "translate(-0.5 0)"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "icon-test",
            "transform": "translate(2.4 2.4)"
          },
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7764",
                "data-name": "路径 7764",
                "class": "cls-3",
                "d": "M18.443,235.085H4.267v-.539c0-3.467,3.175-6.279,7.088-6.279s7.088,2.812,7.088,6.279Zm-13.307-.77H17.574c-.13-2.928-2.87-5.277-6.219-5.277S5.267,231.387,5.136,234.314Zm13.35,3.39H4.267v-2.311h14.22Zm-13.35-.77H17.617v-.77H5.136v.77Z",
                "transform": "translate(-4.267 -223.636)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7765",
                "data-name": "路径 7765",
                "class": "cls-3",
                "d": "M331.536,6.162h-.87a5.161,5.161,0,0,1,2.261-4.044c2.392-1.609,6.262-1.3,11.524.826l-.348.826c-4.871-2.044-8.567-2.348-10.7-.957A4.432,4.432,0,0,0,331.536,6.162Z",
                "transform": "translate(-325.252 -1.096)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7766",
                "data-name": "路径 7766",
                "class": "cls-3",
                "d": "M137.186,817.719m-.652,0a.652.652,0,1,0,.652-.652A.652.652,0,0,0,136.533,817.719Z",
                "transform": "translate(-133.837 -801.65)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7767",
                "data-name": "路径 7767",
                "class": "cls-3",
                "d": "M320.652,817.719m-.652,0a.652.652,0,1,0,.652-.652A.652.652,0,0,0,320,817.719Z",
                "transform": "translate(-313.981 -801.65)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7768",
                "data-name": "路径 7768",
                "class": "cls-3",
                "d": "M506.252,817.719m-.652,0a.652.652,0,1,0,.652-.652A.652.652,0,0,0,505.6,817.719Z",
                "transform": "translate(-496.042 -801.65)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7769",
                "data-name": "路径 7769",
                "class": "cls-3",
                "d": "M228.919,939.319m-.652,0a.652.652,0,1,0,.652-.652A.652.652,0,0,0,228.267,939.319Z",
                "transform": "translate(-223.996 -920.771)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7770",
                "data-name": "路径 7770",
                "class": "cls-3",
                "d": "M412.386,939.319m-.652,0a.652.652,0,1,0,.652-.652A.652.652,0,0,0,411.733,939.319Z",
                "transform": "translate(-403.965 -920.771)"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  